// import {DefaultPinProperties} from "../constants";
import {createClusterTemplate} from "../layouts/createClusterTemplate";

export const initClusterObjectManager = () => new ymaps.ObjectManager({
	clusterize: true,
	// clusterIcons:
	// 	[{
	// 		href: DefaultPinProperties.PATH,
	// 		size: [DefaultPinProperties.WIDTH, DefaultPinProperties.HEIGHT],
	// 		offset: [DefaultPinProperties.WIDTH / 2 * -1, DefaultPinProperties.HEIGHT * -1]
	// 	}],
	clusterIconLayout: createClusterTemplate(),
});
